import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import { ServicesPerYearDonut } from './ServicesPerYearDonut';
import { ServicesPerYearPercentage } from './ServicesPerYearPercentage';
import { ServicesPerMonthPerYearPercentage } from './ServicesPerMonthPerYearPercentage';

const FederalFinancingTotals = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-row-dashboards">
                <ServicesPerYearDonut height={400} />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ServicesPerYearPercentage height={400} />
                <ServicesPerMonthPerYearPercentage height={400} />
            </div>
        </>
    );
};

export default FederalFinancingTotals;
